import {useForm} from "@mantine/form";
import {useTranslation} from "react-i18next";
import {Button, Modal, ModalProps, Stack} from "@mantine/core";
import {useCallback} from "react";
import {getObjectId, PersonEntity} from "@ots-frontend/ots-data";
import {useApp} from "../../../providers/RegionProvider/RegionProvider";
import {PersonSelect} from "../../select/entity/PersonSelect/PersonSelect";

interface DriverActivityFilterFormProps {
  defaultValues?: Partial<DriverActivityFilterFormValues>;
  onSubmit?: (values: DriverActivityFilterFormValues) => void;
}

export interface DriverActivityFilterFormValues {
  person?: PersonEntity | string;
}

export const DEFAULT_DRIVER_ACTIVITY_FILTER: DriverActivityFilterFormValues = {
  person: undefined,
}

export const isDefaultDriverActivityFilter = (filter1: DriverActivityFilterFormValues | undefined): boolean => {
  if (!filter1) {
    return false
  }

  if (filter1 === DEFAULT_DRIVER_ACTIVITY_FILTER) {
    return true
  }

  if (getObjectId(filter1.person) !== getObjectId(DEFAULT_DRIVER_ACTIVITY_FILTER.person)) {
    return false;
  }

  return true;
}

export const DriverActivityFilterForm = (props: DriverActivityFilterFormProps) => {
  const {
    defaultValues,
    onSubmit,
  } = props;

  const {t} = useTranslation(["common"]);

  const {regionId} = useApp()

  const form = useForm({
    initialValues: {
      person: getObjectId(defaultValues?.person),
    },
    validate: {}
  });

  const onFormSubmit = useCallback(async (values: typeof form.values) => {
    if (onSubmit) {
      onSubmit({
        person: values.person,
      });
    }
  }, [form, onSubmit]);

  return (
    <form onSubmit={form.onSubmit(onFormSubmit)}>
      <Stack spacing="md">
        <PersonSelect
          label={t("common.entity.person", "User")}
          placeholder={t<string>("common.entity.person", "User")}
          selector={{
            regionId: regionId,
          }}
          withinPortal={true}
          clearable
          {...form.getInputProps("person")} />
      </Stack>
      <Button type="submit" fullWidth mt="xl">
        {t("common.action.submit", {ns: "common"})}
      </Button>
    </form>
  );
};

interface DriverActivityFilterFormModalProps extends DriverActivityFilterFormProps, Omit<ModalProps, 'onSubmit'> {

}

export const DriverActivityFilterFormModal = (props: DriverActivityFilterFormModalProps) => {
  const {
    defaultValues,
    onSubmit,
    ...rest
  } = props;

  return (
    <Modal {...rest}>
      <DriverActivityFilterForm defaultValues={defaultValues} onSubmit={onSubmit}/>
    </Modal>
  );
};
